export const GET_CROWD_GROUPS_DATA='GET_CROWD_GROUPS_DATA';
export const CROWD_GROUPS_SERVER_ERROR='CROWD_GROUPS_SERVER_ERROR';


// WEBPACK FOOTER //
// ./src/redux/crowdGroup/actionTypes.js